import React from "react";

import { TransitionGroup } from "react-transition-group";

import extraSongsStyles from "../ExtraSongsComponent/ExtraSongsComponent.module.css";
import styles from "./Carousel.module.css";

class Carousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: this.props.items,
      active: this.props.active,
      direction: "",
    };
    this.rightClick = this.moveRight.bind(this);
    this.leftClick = this.moveLeft.bind(this);
  }

  generateItems() {
    var items = [];
    var level;
    for (var i = this.state.active - 2; i < this.state.active + 3; i++) {
      var index = i;
      if (i < 0) {
        index = this.state.items.length + i;
      } else if (i >= this.state.items.length) {
        index = i % this.state.items.length;
      }
      level = this.state.active - i;
      items.push(
        <Item
          key={index}
          id={this.state.items[index]}
          level={level}
          onPlayClick={this.props.onPlay}
        />
      );
    }
    return items;
  }

  moveLeft() {
    var newActive = this.state.active;
    newActive--;
    this.setState({
      active: newActive < 0 ? this.state.items.length - 1 : newActive,
      direction: "left",
    });
  }

  moveRight() {
    var newActive = this.state.active;
    this.setState({
      active: (newActive + 1) % this.state.items.length,
      direction: "right",
    });
  }

  render() {
    return (
      <div
        id="carousel"
        className={`${styles.carousel_wrapper} ${styles.noselect}`}
      >
        <div
          className="arrow arrow-left"
          style={{ left: 0 }}
          onClick={this.leftClick}
        >
          <i className="fi-arrow-left"></i>
        </div>
        <div style={{ marginTop: 150 }}></div>
        <TransitionGroup transitionName={this.state.direction}>
          {this.generateItems()}
        </TransitionGroup>
        <div
          className="arrow arrow-right"
          style={{ right: 0 }}
          onClick={this.rightClick}
        >
          <i className="fi-arrow-right"></i>
        </div>
      </div>
    );
  }
}

class Item extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      level: this.props.level,
    };
  }

  render() {
    const className = "item level" + this.props.level;

    return (
      <div
        className={className}
        style={{
          backgroundImage: `url("${
            process.env.IMAGE_LINK + this.props?.id?.thumbnail
          }")`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
        }}
      >
        <img
          className={extraSongsStyles.song_play_btn}
          src={"/assets/images/play_button.svg"}
          alt="play-icon"
          onClick={() => this.props.onPlayClick(this.props.id)}
        />
        <p className={styles.extra_song_video_title}>{this.props?.id?.title}</p>
      </div>
    );
  }
}

export default Carousel;
